module.exports = __webpack_public_path__ + "img/nkfr_nkfactorytkn.6196454.png";